import { FunnelSimple, FunnelSimpleX } from "@phosphor-icons/react"
import { formatForDisplay } from "@tanstack/react-hotkeys"
import { useRegisterSearchCommands } from "~/components/sidebar/search/useRegisterSearchCommands"
import { HOTKEYS } from "~/constants/hotkeys"

type FilterSearchCommandsArgs = {
  enabled: boolean
  hasFilters: boolean
  openFilters: () => void
  clearFilters: () => void
}

/** "Add filter" / "Clear filters" in the command center for a page's main filter popover */
export function useFilterSearchCommands({
  enabled,
  hasFilters,
  openFilters,
  clearFilters,
}: FilterSearchCommandsArgs) {
  const canClear = enabled && hasFilters

  useRegisterSearchCommands(
    enabled
      ? [
          {
            id: "add-filter",
            name: "Add filter",
            keywords: ["filter", "open filters"],
            icon: <FunnelSimple />,
            shortcut: [formatForDisplay(HOTKEYS.openFilterPopover.hotkey)],
            run: openFilters,
          },
          {
            id: "clear-filters",
            name: "Clear filters",
            keywords: ["filter", "reset", "remove filters"],
            icon: <FunnelSimpleX />,
            disabledReason: canClear ? undefined : "No filters to clear",
            run: clearFilters,
          },
        ]
      : [],
    [enabled, canClear],
  )
}
